module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.overrideSettings,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          on: {
            "click": function($event) {
              return _vm.fncSaveOverride(props.item.id, props.item.override)
            }
          },
          model: {
            value: (props.item.override),
            callback: function($$v) {
              _vm.$set(props.item, "override", $$v)
            },
            expression: "props.item.override"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_vm._v(_vm._s(props.item.fullname))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-1 pb-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])])], 1)], 1)
},staticRenderFns: []}